import { render } from "./DelegateDialog.vue?vue&type=template&id=ae042570&scoped=true"
import script from "./DelegateDialog.vue?vue&type=script&lang=js"
export * from "./DelegateDialog.vue?vue&type=script&lang=js"

import "./DelegateDialog.vue?vue&type=style&index=0&id=ae042570&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae042570"]])

export default __exports__